import React, { useState } from 'react';
import { Image, Hardware } from '../../../Cloud.model';
import { getMemoryLabel, selectedHardwareDoesntSupportsSelectedImage } from './utils';
import './LockImage.scss';
import { formatVCpuLabel } from '@/components/Cloud/Atoms/hardwareLabel/HardwareLabelUtils';

export interface UHCLockImageProps {
    image: Image,
    hardware: Hardware
    handleClick: Function;
    children: (isBlocked: boolean) => React.ReactNode;
    currentLockOpen: string
    setCurrentLockOpen: React.Dispatch<React.SetStateAction<string>>
}

const UHCLockImage: React.FC<UHCLockImageProps> = (props: UHCLockImageProps) => {
    const [showComponent, setShowComponent] = useState(false);
    const [inputContentFocus, setInputContentFocus] = useState<string>();

    const isMinHardware = selectedHardwareDoesntSupportsSelectedImage(props.image, props.hardware);
    const memory = getMemoryLabel(props.image.minRequirements.memory);
    const vcpu = formatVCpuLabel(props.image.minRequirements.vcpu);

    function mouseOn(bool: boolean) {
        setShowComponent(bool)
    }

    const handleFocus = (event: React.FocusEvent | React.MouseEvent) => {
        const target = event.target as HTMLInputElement;

        const elementContent = target.parentElement.textContent

        if (target.tagName === 'INPUT') {
            props.setCurrentLockOpen(elementContent)

            if (!inputContentFocus) setInputContentFocus(elementContent)
        }

        mouseOn(true)
    }

    const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
        const isInsideTabPanel = e.relatedTarget?.closest('div[role="tabpanel"]')
        if (!isInsideTabPanel) mouseOn(false)

        e.relatedTarget === null && mouseOn(false)
    }

    const isCurrentOpen = (!props.currentLockOpen || !inputContentFocus) || inputContentFocus === props.currentLockOpen

    return (
        <div style={{ position: 'relative' }}
            tabIndex={-1}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onMouseEnter={handleFocus}
            onMouseLeave={() => mouseOn(false)}
        >
            {showComponent && isMinHardware && isCurrentOpen ? (
                <div role="alert" aria-live="polite" data-testid='UHCLockImageFuncion' className='container-function'>
                    <div className='container-lock-image' data-testid='UHCLockImageComponent'>
                        <p>Opção disponível a partir de: {memory} de RAM, {vcpu} e {props.image.minRequirements.disk} GB de Disco -
                            <button
                                type="button"
                                autoFocus
                                onClick={e => {
                                    e.preventDefault();
                                    props.handleClick(props.image)
                                }}
                            >
                                Alterar para essa configuração
                            </button>
                        </p>
                    </div>
                </div>
            ) : null}
            {props.children(isMinHardware)}
        </div>
    );
};

export default UHCLockImage;
